import React from 'react';

import styles from './checkbox-group.scss';

interface CheckboxGroupProps {
  children: React.ReactNode;
  groupTitle: string;
}

function CheckboxGroup(props: CheckboxGroupProps) {
  const { children, groupTitle } = props;

  return (
    <div className={styles['container']}>
      <fieldset>
        <legend>{groupTitle}</legend>
        {children}
      </fieldset>
    </div>
  );
}

export default CheckboxGroup;
